/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	/**
	* Upgrade VIDA property. Remove title.visible from the old spec and introduce 'itemAxis.title.visible' and 'valueAxis.title.visible' instead.
	**/

	class VIDAPaddingPropUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 1300;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}

			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			_.each(spec.widgets, model => {
				if (model && this._isLive(model)) {
					if (!model.properties) {
						model.properties = [];
					}
					this._noPaddingPropertyUpgrade(model);
				}
			});

			return Promise.resolve(spec);
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		_isLive(model) {
			return model && model.type && model.type === 'live';
		}

		_noPaddingPropertyUpgrade(model) {
			const deprecatedPropId = ['bar.noPadding'];
			const deprecatedProp = WidgetUpgradeUtils.findProperty(deprecatedPropId[0], model.properties);
			const newPropId = ['bar.padding'];
			const newProp = WidgetUpgradeUtils.findProperty(newPropId[0], model.properties);

			// clean up the spec poperties by filter out the deprecated props
			model.properties = _.filter(model.properties, (prop) => { return (deprecatedPropId[0] !== prop.id); });

			// add new property if not already present
			if(!newProp){
				model.properties.push({
					id: newPropId[0],
					value: deprecatedProp ? !deprecatedProp.value : true
				});
			}
		}
	}

	return new VIDAPaddingPropUpgrade();
});
